import RadioGroup from '../radio/radio-group.vue'

/* istanbul ignore next */
RadioGroup.install = function (Vue) {
  Vue.component(RadioGroup.name, RadioGroup)
}

export default RadioGroup
